<img src="{{ source }}" class="sil-illustration" alt="{{ illustration }}">
